import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { dataAll } from '../../../service/data.service'
import MonthYearPicker from '../../MonthYearPicker'
import StatePicker from '../../StatePicker'
import FranchiseePicker from '../../FranchiseePicker'
import FilterFieldsLeftButtonRight from '../../Filter/FilterFieldsLeftButtonRight'
import DRETable from './DRETable'
import { Loading } from '../../Loading'

const filtersSample = { state: '', franchisee: '' }

const DREMainPage = ({ title, endpoint, isClub = false }) => {
  const [report, setReport] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [startDate, setStartDate] = useState({ month: 1, year: 2025 })
  const [endDate, setEndDate] = useState({ month: 12, year: 2025 })
  const [filters, setFilters] = useState(filtersSample)

  const clearFilter = () => {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth() + 1
    setStartDate({ month: 1, year: currentYear })
    setEndDate({ month: currentMonth, year: currentYear })
    if (isClub) setFilters(filtersSample)
  }

  useEffect(() => {
    clearFilter()
  }, [])

  const fetchAllItems = async () => {
    const filtro = {
      startYear: startDate.year,
      startMonth: startDate.month,
      endYear: endDate.year,
      endMonth: endDate.month,
      ...(isClub ? filters : {}),
    }

    try {
      setIsLoading(true)
      const response = await dataAll(endpoint, { params: filtro })
      setReport(response)

    } catch (error) {
      toast.error('Erro ao buscar relatório de fechamento mensal. Favor tentar novamente dentro de alguns instantes. Sinalize o suporte caso persista.')
    
    } finally {
      setIsLoading(false)
    }
  }

  const clickFilter = () => fetchAllItems()

  return (
    <>
      <h2>{title}</h2>
      <FilterFieldsLeftButtonRight clickFilter={clickFilter} clearFilter={clearFilter}>
        <MonthYearPicker label="Início" value={startDate} onChange={setStartDate} />
        <MonthYearPicker label="Fim" value={endDate} onChange={setEndDate} />
        {isClub && (
          <>
            <StatePicker value={filters} onChange={setFilters} />
            <FranchiseePicker value={filters} onChange={setFilters} />
          </>
        )}
      </FilterFieldsLeftButtonRight>

      {isLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '128px' }}>
          <Loading />
        </div>
      ) : (
        report && <DRETable periods={report.periods} rows={report.rows} />
      )}
    </>
  )
}

DREMainPage.propTypes = {
  title: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  isClub: PropTypes.bool,
};

DREMainPage.defaultProps = {
  isClub: false,
};

export default DREMainPage
